export default "__VITE_PUBLIC_ASSET__636cb7cf__"